
export default Object.freeze({});